export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_SUBCATEGORIES = 'GET_SUBCATEGORIES';
export const SET_CHOSEN_CAT = 'SET_CHOSEN_CAT';
export const SHOW_CATEGORY = 'SHOW_CATEGORY';
export const SET_CATEGORIES_LOADED = 'SET_CATEGORIES_LOADED';
export const GET_CATEGORIES_HIERARCHY = 'GET_CATEGORIES_HIERARCHY';
export const SET_HIERARCHY_LEVEL = 'SET_HIERARCHY_LEVEL';
export const LOADING_HIERARCHY_START = 'LOADING_HIERARCHY_START';
export const LOADING_HIERARCHY_END = 'LOADING_HIERARCHY_END';
export const SET_SELECTED_CAT_ID = 'selected_cat_hierarchy_id';